import React from 'react'


function Head() {
    return (
        <div>
            <header className='head'>
                <div className='logo'>
                <span>&lt;My</span><span>ToDo&gt;</span>
                </div>
            </header>
        </div>
    )
}

export default Head
